import styled from "styled-components";

const StepContainer = styled.div`
    ${({visible}) => visible ? '' : 'display: none;'}
`;
export default StepContainer;